// extracted by mini-css-extract-plugin
module.exports = {"l1etwsvd":"l1etwsvd"};